import { Check, Database, GitBranch, LoaderCircle, Search } from "lucide-react";
import { Logo } from "./Logo";
import { CHAIN_LABELS, shortAddress } from "../lib/format";
import type { TokenCandidate } from "../../server/types";

const steps = [
  { icon: Search, title: "Resolve token identity" },
  { icon: Database, title: "Snapshot largest holders" },
  { icon: GitBranch, title: "Trace holder transfers" },
  { icon: LoaderCircle, title: "Build wallet clusters" },
];

export function Scanning({ token, stage }: { token: TokenCandidate; stage: number }) {
  return (
    <main className="scanning-page">
      <div className="scan-grid" />
      <header><Logo /></header>
      <section className="scan-card">
        <div className="scanner-visual" aria-hidden="true">
          <span className="scanner-orbit scanner-orbit--a"><i /></span>
          <span className="scanner-orbit scanner-orbit--b"><i /></span>
          <span className="scanner-orbit scanner-orbit--c"><i /></span>
          <span className="scanner-core">
            {token.imageUrl ? <img src={token.imageUrl} alt="" /> : token.symbol.slice(0, 3)}
          </span>
        </div>
        <div className="scan-kicker">Building live map</div>
        <h1>{token.name}</h1>
        <p>{CHAIN_LABELS[token.chain]} · {shortAddress(token.address, 8)}</p>
        <div className="scan-steps">
          {steps.map((item, index) => {
            const Icon = item.icon;
            const state = index < stage ? "done" : index === stage ? "active" : "pending";
            return (
              <div key={item.title} className={`scan-step scan-step--${state}`}>
                <span>{state === "done" ? <Check size={16} /> : <Icon size={16} />}</span>
                <strong>{item.title}</strong>
                <small>{state === "done" ? "Complete" : state === "active" ? "Working…" : "Queued"}</small>
              </div>
            );
          })}
        </div>
        <small className="scan-note">Public nodes can take a little longer while transfer history is decoded.</small>
      </section>
    </main>
  );
}
